
/**
 * @description  根据列表 value 获取 label
 * @param {*} list 
 * @param {*} value 
 * @param {*} key 
 * @param {*} label 
 * @returns 
 */
export function getDictOptionsLabel(
    list = [],
    value = null,
    key = "value",
    label = 'label'
) {
    if (!['string', 'number'].includes(typeof value) || list.length === 0)
        return '-'
    const obj = list.find((item) => item[key] === value)
    return obj ? obj[label] : '-'
}